import './article_3.scss';
import BI from './assets/bi.png';
import img_0 from './assets/0.png';

export default function Article_3() {

    window.scrollTo(0, 0);

    return (
        <div className="article_3">
            <img src={BI} alt="header" />
            <div className="content">
                <h2>
                    Куда инвестирует принц Саудовской Аравии
                </h2>
                <h5>
                    Состояние принца Саудовской Аравии Аль-Валид ибн Талала оценивается в $20 млрд. В какие активы вкладывает деньги племянник короля и внук основателя Саудовской Аравии
                </h5>
                <img src={img_0} alt="img_0" />
                <p>
                    Аль-Валид ибн Талал ибн Абдель Азиз Аль Сауд (Alwaleed Bin Talal) — племянник короля, внук основателя Саудовской Аравии. Владеет активами на сумму около $20 млрд, которые он заработал на инвестициях в ценные бумаги. Своим личным состоянием Аль-Валид управляет через компанию Kingdom Holding, которая была основана в 1980 году.
                </p>
                <p>
                    В инвестиционном портфеле компании доминируют коммерческая недвижимость, финансовые услуги, туризм, гостиничный сектор, СМИ, развлечения, нефтехимия, авиация и технологии. Структура портфеля меняется раз в несколько лет.
                </p>
                <h5>
                    Самая успешная инвестиция
                </h5>
                <p>
                    В январе 1990 года Аль-Валид купил акции Citigroup на 600 миллионов долларов. Тогда они были на минимальном уровне и через 10 лет выросли в 25 раз. Аль-Валид и сегодня остается крупнейшим частным акционером Citigroup.
                </p>
                <h5>
                    Инвестировал до того как это стало мейнстримом
                </h5>
                <p>
                    В девяностых принц инвестировал в компанию, которая сейчас является самой дорогой в мире, – Apple. Тогда ему принадлежало 5%. Аль-Валид также одним из первых вложился в JD.com. В его портфеле побывали и акции Amazon, eBay, Coca-Cola, PepsiCo, McDolnald's, Ford, Procter & Gamble, Walt Disney.
                </p>
                <h5>
                    Текущие компании в инвестиционном порфтеле:
                </h5>
                <ul>
                    <li>
                        Four Seasons Hotels & Resorts (Canada-based) (owns 45% with Cascade Investment, LLC, and others)
                    </li>
                    <li>
                        Fairmont Raffles Swissotel (minority ownership with Accor)
                    </li>
                    <li>
                        Hotel George V (100%) (France)
                    </li>
                    <li>
                        KADCO Egypt (100%) (Egypt)
                    </li>
                    <li>
                        Kingdom Hospital-Consulting Clinics[citation needed] (100%) (Saudi Arabia)
                    </li>
                    <li>
                        Kingdom Hotels Investments (100%) (Saudi Arabia)
                    </li>
                    <li>
                        Lebanese Broadcasting Corporation (100%) (Lebanon)
                    </li>
                    <li>
                        Lyft (US)Mövenpick Hotels & Resorts (33%) (Switzerland[citation needed])
                    </li>
                    <li>
                        Flynas (33%) (Saudi Arabia)
                    </li>
                    <li>
                        National Industrialization Company (100%) (Saudi Arabia)
                    </li>
                    <li>
                        Rotana Group, the Arab world's largest entertainment company (100%) (Saudi Arabia)
                    </li>
                    <li>
                        Saudi Research & Marketing Group (100%) (Saudi Arabia)
                    </li>
                </ul>
            </div>
        </div>
    )
}